import { get, post, patch, destroy } from './httpClient'

export const getRegions = (query) => get('/region', query)
export const addRegion = (body) => post('/region/create', body)
export const updateRegion = (id, body) => patch('/region/update/' + id, body)
export const deleteRegion = (ids) => destroy('/region/delete', { region_id: ids })
export const getAllRegion = (query) => get('/address/country', query)
